<!--
Copyright 2021 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<div class="content">
  @if (design$ | async; as design) {
    @if (!design.enabled) {
      <h3
        class="disabled"
        matTooltip="This Design will not be included in a Workspace until it is enabled"
        >
        Disabled
      </h3>
    }
  }

  <mat-expansion-panel (opened)="loadVariables()">
    <mat-expansion-panel-header>
      <mat-panel-title> Variables </mat-panel-title>
      <mat-panel-description>
        Manage re-usable values to customize your Design
      </mat-panel-description>
    </mat-expansion-panel-header>

    <ng-template matExpansionPanelContent>
      <cas-variables [designId]="designId" [canEdit]="canEdit"></cas-variables>
    </ng-template>
  </mat-expansion-panel>

  <cas-design-modules
    [designId]="designId"
    [canEdit]="canEdit"
  ></cas-design-modules>
</div>
